var map = {
	"./address_image.svg": 193,
	"./airbnbLogo.png": 194,
	"./animated_ashutosh.png": 195,
	"./animated_logo.svg": 196,
	"./arxiv.png": 197,
	"./aws-amplify.png": 198,
	"./aws.png": 199,
	"./blogs_image.svg": 200,
	"./bootstrap.png": 201,
	"./capture_it.png": 202,
	"./capture_it_colored.jpg": 73,
	"./cloud_infrastructure.svg": 203,
	"./codeInLogo.png": 204,
	"./codeInLogo.webp": 205,
	"./contactMail.png": 206,
	"./contactMail.webp": 207,
	"./contactMailDark.svg": 94,
	"./coursera_logo.png": 208,
	"./covaccine.webp": 71,
	"./css3.png": 209,
	"./data_science.svg": 210,
	"./deeplearning_ai_logo.png": 77,
	"./delhivery_logo.png": 211,
	"./developerActivity.svg": 212,
	"./django.png": 213,
	"./docker.png": 214,
	"./dsc_logo.png": 215,
	"./education.svg": 216,
	"./experience.svg": 217,
	"./facebookLogo.png": 218,
	"./feelingProud.svg": 219,
	"./fhs.png": 220,
	"./firebase.png": 221,
	"./flutter.png": 222,
	"./freecopy_logo.png": 223,
	"./fullstack.svg": 224,
	"./gcloud.png": 68,
	"./gcp.png": 225,
	"./gcp_logo.png": 226,
	"./git.png": 227,
	"./github_logo.png": 67,
	"./gmail.png": 228,
	"./googleAssistant.jpg": 229,
	"./googleAssistant.svg": 230,
	"./googleAssistantLogo.webp": 231,
	"./google_logo.png": 75,
	"./green_doctor.png": 72,
	"./hackerbash.jpg": 232,
	"./hackerbash_circle.png": 69,
	"./hackerearth.png": 233,
	"./hackerrank.png": 234,
	"./harvardLogo.png": 235,
	"./heroku-logo.png": 236,
	"./heroku.png": 237,
	"./html.svg.png": 238,
	"./html5.png": 239,
	"./hugging-faces.png": 240,
	"./ibm_logo.png": 241,
	"./iiitk_logo.png": 242,
	"./instagram.png": 243,
	"./intel_logo.jpg": 244,
	"./java-resize.png": 245,
	"./java.png": 246,
	"./java.svg": 247,
	"./js.png": 248,
	"./jsFramework.svg": 249,
	"./kaggle.png": 250,
	"./kaggle.svg": 251,
	"./kitten.png": 252,
	"./kjssc.png": 253,
	"./leetcode.png": 91,
	"./leetcode_darktheme.png": 254,
	"./leetcode_lighttheme.png": 255,
	"./legato_logo.png": 256,
	"./linkedin.png": 257,
	"./linkedin_dp.jpeg": 258,
	"./manOnTable.svg": 259,
	"./microsoft_logo.png": 260,
	"./moon.svg": 261,
	"./mozilla_logo.png": 262,
	"./muffito_logo.png": 263,
	"./mumbai_police.png": 70,
	"./mysql.png": 264,
	"./nextjs.png": 265,
	"./nextuLogo.jpg": 266,
	"./nextuLogo.webp": 267,
	"./node.png": 268,
	"./node_1.png": 269,
	"./npm.png": 270,
	"./nptel_logo.png": 271,
	"./nxtbig.png": 272,
	"./nxtbig_white.png": 48,
	"./nxtbiglogo.png": 273,
	"./opencv.png": 274,
	"./p4p.png": 275,
	"./portfolio.gif": 276,
	"./postgres.png": 277,
	"./prisma.png": 278,
	"./programmer.svg": 279,
	"./projects_image.svg": 280,
	"./psu.png": 46,
	"./pwa.png": 281,
	"./pwa.webp": 282,
	"./pwaLogo.webp": 283,
	"./python.png": 284,
	"./pytorch.png": 285,
	"./quoraLogo.png": 286,
	"./reactjs.png": 287,
	"./redux.png": 288,
	"./saayaHealthLogo.png": 289,
	"./saayaHealthLogo.webp": 290,
	"./scholar.png": 92,
	"./skill.svg": 291,
	"./somaiya.jpg": 47,
	"./somaiya.jpg.webp": 292,
	"./somaiya.png": 293,
	"./spring.png": 294,
	"./stanfordLogo.png": 295,
	"./stanford_logo.png": 76,
	"./sun.svg": 296,
	"./supabase.png": 297,
	"./sybgen_logo.jpg": 298,
	"./sybgen_logo.png": 299,
	"./sybgenlogo.png": 74,
	"./symbl.ai-logo.png": 300,
	"./talksCardBack.svg": 301,
	"./talksCardBackAlt.svg": 302,
	"./tensorflow.png": 303,
	"./typescript.png": 304,
	"./ui_ux_design.svg": 305,
	"./undraw_intro.svg": 93,
	"./undraw_programming.svg": 95,
	"./undraw_progressbars.svg": 96,
	"./wandb.png": 306,
	"./yarn.png": 307
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 192;